const Spinner = () => {
    return (
        <div className="spinner position-fixed w-100 h-100 d-flex flex-column align-items-center justify-content-center">
            <div className="spinner-border mb-2" role="status"></div>   
        </div>
    );
}

export default Spinner;